const typeRegistration = [
  { value: 'RO', label: 'REGISTRO DE OCORRÊNCIA - RO' },
  { value: 'RCA', label: 'REGISTRO DE COMUNICAÇÕES ADMINISTRATIVAS - RCA' },
  { value: 'RI', label: 'REGISTRO INTERNO - RI' },
];

export default typeRegistration;
